import React, { useState, useEffect } from "react";
import {
  getAllGramPanchayat,
  getSacivDetails,
  updateSachivDetails,
} from "../../api/User";

import { ToastContainer, toast } from "react-toastify";
import { Avatar } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Button } from 'antd';


const SachivProfile = () => {
  const [update, setUpdate] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  const user_id = sessionStorage.getItem("user_id");
  const token = sessionStorage.getItem("token");
  const [sachivDetails, setSachivDetails] = useState([]);
  const [gramPanchayat, setGramPanchayat] = useState([]);
  const [gramPanchayatLength, setGramPanchayatLength] = useState(1);
  const [imageSrc, setImageSrc] = useState("");
  const phoneRegex = /^[6-9][0-9]{9}$/;
  const [errors, setErrors] = useState({
    name: "",
    mobile_number: "",
    email: "",
    address: "",
    panchayat_website: "",
    other_website: "",
  });
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const urlRegex = /^(ftp|http|https):\/\/[^ "]+$/;

  const handleUpdate = () => {
    setUpdate(true);
  };

  const fetchData = async () => {
    try {
      const res = await getSacivDetails(token, user_id);
      setSachivDetails(res.data.result[0]);
      setImageSrc(
        `data:image/jpeg/png/jpg;base64, ${res.data.result[0].gram_sachiv_photo_base64}`
      );
    } catch (error) {
      console.error("Error fetching profile data:", error);
    }
  };
  const fetchAllGramPanchayat = async () => {
    try {
      const res = await getAllGramPanchayat(token, user_id);
      setGramPanchayat(res.data);
      setGramPanchayatLength(res.data.length);
    } catch (error) {
      console.error("Error fetching gram  panchayat data:", error);
    }
  };

  useEffect(() => {
    fetchData();
    fetchAllGramPanchayat();
  }, []);
  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSachivDetails({ ...sachivDetails, file: file });
      setImagePreview(URL.createObjectURL(file));
    }
  };
  const handleCancelUpdate = () => {
    setUpdate(false);
    setImagePreview(null);
    setErrors({});
    window.location.reload();
  };
  const validateField = (field, value) => {
    switch (field) {
      case "name":
        if (!value || value == "") return "Name is required.";
        return "";
      case "mobile_number":
        if (!value || !phoneRegex.test(value))
          return "Invalid mobile number format.";
        return "";
      case "email":
        if (!value || value == "" || !emailRegex.test(value))
          return "Invalid email format.";
        return "";
      case "panchayat_website":
        if (!value || value == "" || !urlRegex.test(value))
          return "Invalid website format.";
        return "";
      case "other_website":
        if (value && !urlRegex.test(value)) {
          return "Invalid website format.";
        }
        if (value == "") {
          return "";
        }
        return "";
      case "address":
        if (!value || value == "") return "Address is required.";
        return "";
      default:
        return "";
    }
  };

  const handleSave = async () => {
    const newErrors = validateInputs();

    const hasErrors = Object.keys(newErrors).some(
      (key) => newErrors[key] !== "" && key !== "other_website"
    );

    if (hasErrors) {
      setErrors(newErrors);
      toast.error("Please fill all the required fields.");
      return;
    }
    if (errors.other_website != "") {
      toast.error("Please fill all the required fields.");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("user_id", user_id);
      Object.keys(sachivDetails).forEach((key) => {
        formData.append(key, sachivDetails[key]);
      });

      const res = await updateSachivDetails(token, formData);
      toast.success(res.message);
      setUpdate(false);
      setImagePreview(imagePreview !== null ? imagePreview : null);
      fetchData();
      setErrors({});
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } catch (error) {
      console.error("Error updating profile:", error);
    }
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    const errorMessage = validateField(id, value);
    setSachivDetails({
      ...sachivDetails,
      [id]: [value],
    });
    setErrors({
      ...errors,
      [id]: errorMessage,
    });
  };
  const validateInputs = () => {
    const newErrors = {};
    Object.keys(sachivDetails).forEach((key) => {
      newErrors[key] = validateField(key, sachivDetails[key]);
    });
    return newErrors;
  };
  const handleKeyPress = (e) => {
    const char = String.fromCharCode(e.which);
    if (!/[a-zA-Z\s]/.test(char)) {
      e.preventDefault();
    }
  };
  const dealersOutstanding = [
    {
      dealer_person_name: "ADHO MAJRA",
      outstanding: 1500,
    },
    {
      dealer_person_name: "AMIPUR",
      outstanding: 2500,
    },
    {
      dealer_person_name: "BALAPUR",
      outstanding: 3200,
    },
  ];

  return (
    <div
      className="container-fluid"
      style={{ background: "#fff", overflowX: "hidden" }}
    >
      <h2 className="" style={{ top: "0", left: "0", margin: "16px", fontWeight: "bold", marginLeft: "1.5%" }}>Gram Sachiv Details</h2>

      <div style={{
        backgroundColor: "white",
        borderRadius: "12px",
        padding: "20px",
        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
        margin: "16px"
      }}>
        <div
          className="container-fluid"
          style={{ background: "#fff", overflowX: "hidden" }}
        >
          <div className="row pt-5">
            <div className="col-md-8">

              <form className="row g-3 mb-3">

                <div className="col-md-6">
                  <label
                    htmlFor="name"
                    className="form-label"
                    style={{ fontWeight: "bold" }}
                  >
                    Gram Sachiv Name <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    className={`form-control ${errors.name ? "is-invalid" : ""}`}
                    id="name"
                    defaultValue={sachivDetails.name}
                    disabled={!update}
                    style={{ textTransform: "uppercase" }}
                    onChange={handleChange}
                    onKeyPress={handleKeyPress}
                  />
                  {errors.name && (
                    <div className="invalid-feedback">{errors.name}</div>
                  )}
                </div>

                <div className="col-md-6">
                  <label
                    htmlFor="mobile_number"
                    className="form-label"
                    style={{ fontWeight: "bold" }}
                  >
                    Mobile Number <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    className={`form-control ${errors.mobile_number ? "is-invalid" : ""
                      }`}
                    id="mobile_number"
                    defaultValue={sachivDetails.mobile_number}
                    disabled={!update}
                    onChange={handleChange}
                    maxLength={10}
                  />
                  {errors.mobile_number !== "" && (
                    <div className="invalid-feedback">{errors.mobile_number}</div>
                  )}
                </div>

                <div className="col-md-6">
                  <label
                    htmlFor="email"
                    className="form-label"
                    style={{ fontWeight: "bold" }}
                  >
                    Email ID <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="email"
                    className={`form-control ${errors.email ? "is-invalid" : ""}`}
                    id="email"
                    defaultValue={sachivDetails.email}
                    disabled={!update}
                    style={{ textTransform: "lowercase" }}
                    onChange={handleChange}
                  />
                  {errors.email !== "" && (
                    <div className="invalid-feedback">{errors.email}</div>
                  )}
                </div>

                <div className="col-md-6">
                  <label
                    htmlFor="designation"
                    className="form-label"
                    style={{ fontWeight: "bold" }}
                  >
                    Designation <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="designation"
                    defaultValue={sachivDetails.designation}
                    style={{ textTransform: "uppercase" }}
                    disabled
                    onChange={handleChange}
                  />
                </div>

                <div className="col-md-6">
                  <label
                    htmlFor="address"
                    className="form-label"
                    style={{ fontWeight: "bold" }}
                  >
                    Address <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    className={`form-control ${errors.address ? "is-invalid" : ""}`}
                    id="address"
                    defaultValue={sachivDetails.address}
                    disabled={!update}
                    style={{ textTransform: "uppercase" }}
                    onChange={handleChange}
                  />
                  {errors.address !== "" && (
                    <div className="invalid-feedback">{errors.address}</div>
                  )}
                </div>

                <div className="col-md-6">
                  <label
                    htmlFor="block"
                    className="form-label"
                    style={{ fontWeight: "bold" }}
                  >
                    Block <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="block"
                    defaultValue={sachivDetails.block}
                    disabled
                    onChange={handleChange}
                  />
                </div>

                <div className="col-md-6">
                  <label
                    htmlFor="gram_panchayat_name"
                    className="form-label"
                    style={{ fontWeight: "bold" }}
                  >
                    Gram Panchayat Name <span style={{ color: "red" }}>*</span>
                  </label>
                  {gramPanchayatLength > 1 ? (
                    // <div>
                    // <Button type="default" style={{ backgroundColor: "#EFEBF1", marginRight: "10px", width: "100%" }} data-bs-toggle="modal"
                    //   data-bs-target="#gramPanchayat">
                    //             Show All Gram Panchayat
                    //         </Button>
                    // </div>
                    <div>
                      <input
                        type="text"
                        className="form-control"
                        id="gram_panchayat_name"
                        defaultValue={sachivDetails.gram_panchayat}
                        readOnly
                        disabled
                        onChange={handleChange}
                      />
                    </div>
                  ) : (
                    <div>


                      <input
                        type="text"
                        className="form-control"
                        id="gram_panchayat_name"
                        defaultValue={sachivDetails.gram_panchayat}
                        readOnly
                        disabled
                        onChange={handleChange}
                      />
                    </div>
                  )}
                </div>

                <div className="col-md-6">
                  <label
                    htmlFor="panchayat_website"
                    className="form-label"
                    style={{ fontWeight: "bold" }}
                  >
                    Panchayat Website (if any){" "}
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    className={`form-control ${errors.panchayat_website ? "is-invalid" : ""
                      }`}
                    id="panchayat_website"
                    defaultValue={sachivDetails.panchayat_website}
                    disabled={!update}
                    placeholder="https://www.example.com"
                    onChange={handleChange}
                  />
                  {errors.panchayat_website !== "" && (
                    <div className="invalid-feedback">
                      {errors.panchayat_website}
                    </div>
                  )}
                </div>

                <div className="col-md-6">
                  <label
                    htmlFor="other_website"
                    className="form-label"
                    style={{ fontWeight: "bold" }}
                  >
                    If Any Other Website (optional)
                  </label>
                  <input
                    type="text"
                    className={`form-control ${errors.other_website ? "is-invalid" : ""
                      }`}
                    id="other_website"
                    defaultValue={sachivDetails.other_website}
                    disabled={!update}
                    placeholder="https://www.example.com"
                    onChange={handleChange}
                  />
                  {errors.other_website !== "" && (
                    <div className="invalid-feedback">{errors.other_website}</div>
                  )}
                </div>

                <div className="col-md-6">
                  <label
                    htmlFor="photograph"
                    className="form-label"
                    style={{ fontWeight: "bold" }}
                  >
                    Upload Photograph
                  </label>
                  <input
                    type="file"
                    className="form-control"
                    id="photograph"
                    accept="image/*"
                    disabled={!update}
                    onChange={handleImageUpload}
                  />
                </div>
              </form>
            </div>

            <div className="col-sm-12 col-md-6 col-lg-4">
              <div
                className="profile-image"
                style={{
                  margin: "20px auto",
                  overflow: "hidden",
                  borderRadius: "50%",
                  height: "35vh",
                  width: "35vh",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {imagePreview ? (
                  <Avatar
                    src={imagePreview}
                    alt="Profile Preview"
                    className="img-fluid"
                    style={{
                      height: "100%",
                      width: "100%",
                      objectFit: "cover",
                      borderRadius: "50%",
                    }}
                  />
                ) : (
                  <Avatar
                    src={imageSrc}
                    alt=""
                    className="img-fluid"
                    style={{
                      height: "100%",
                      width: "100%",
                      objectFit: "cover",
                      borderRadius: "50%",
                    }}
                  />
                )}
              </div>
              <div className="d-flex justify-content-center mt-3">
                {!update ? (
                  <button
                    className="btn"
                    onClick={handleUpdate}
                    style={{
                      width: "35%",
                      backgroundColor: "#4763E430",
                      color: "#4763E4",
                      border: "none",
                      padding: "10px 20px",
                      borderRadius: "4px",
                      cursor: "pointer",
                    }}
                    onMouseOver={(e) => {
                      e.target.style.backgroundColor = "#4763E4";
                      e.target.style.color = "#fff";
                    }}
                    onMouseOut={(e) => {
                      e.target.style.backgroundColor = "#4763E430";
                      e.target.style.color = "#4763E4";
                    }}
                  >
                    Update Profile
                  </button>

                ) : (
                  <>
                    <button
                      type="button"
                      className="btn me-2"
                      onClick={handleSave}
                      style={{
                        width: "35%",
                        backgroundColor: "#4763E430",
                        color: "#4763E4",
                        border: "none",
                        padding: "10px 20px",
                        borderRadius: "4px",
                        cursor: "pointer",
                      }}
                      onMouseOver={(e) => {
                        e.target.style.backgroundColor = "#4763E4";
                        e.target.style.color = "#fff";
                      }}
                      onMouseOut={(e) => {
                        e.target.style.backgroundColor = "#4763E430";
                        e.target.style.color = "#4763E4";
                      }}
                    >
                      Save
                    </button>

                    <button
                      type="reset"
                      className="btn"
                      onClick={handleCancelUpdate}
                      style={{
                        width: "35%",
                        backgroundColor: "#4763E430",
                        color: "#4763E4",
                        border: "none",
                        padding: "10px 20px",
                        borderRadius: "4px",
                        cursor: "pointer",
                      }}
                      onMouseOver={(e) => {
                        e.target.style.backgroundColor = "#4763E4";
                        e.target.style.color = "#fff";
                      }}
                      onMouseOut={(e) => {
                        e.target.style.backgroundColor = "#4763E430";
                        e.target.style.color = "#4763E4";
                      }}
                    >
                      Cancel
                    </button>

                  </>
                )}
              </div>
            </div>
          </div>


          <ToastContainer />
          <div
            className="modal fade"
            id="gramPanchayat"
            tabIndex="-1"
            aria-labelledby="gramPanchayatModalLabel"
            aria-hidden="true"
            style={{ width: "100%" }}
          >
            <div className="modal-dialog modal-dialog-centered ">
              <div className="modal-content">
                <div className="modal-header justify-content-center">
                  <h1 className="modal-title fs-5 text-center" id="outstandingModalLabel" style={{ flex: 1, fontWeight: "bold" }}>
                    {"Total Gram Panchayat"}
                  </h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <div className="modal-body p-0">
                  <div className="table-responsive">
                    <TableContainer
                      component={Paper}
                      style={{
                        boxShadow: "0px 13px 20px 0px #80808029",
                        maxHeight: "400px",

                      }}
                    >
                      <Table aria-label="simple table">
                        <TableHead
                          style={{
                            position: "sticky",
                            top: 0,
                            zIndex: 1,
                            backgroundColor: "#d0ecf7",
                            overflow: "hidden",
                          }} >
                          <TableRow>
                            <TableCell align="center" style={{ fontWeight: "bold" }}>{"Sr. No."}</TableCell>
                            <TableCell align="center" style={{ fontWeight: "bold" }}>
                              {"Gram Panchayat Code"}
                            </TableCell>
                            <TableCell align="center" style={{ fontWeight: "bold" }}>
                              {"Gram Panchayat Name"}
                            </TableCell>
                          </TableRow>
                        </TableHead>

                        <TableBody style={{ color: "white" }}>
                          {gramPanchayat && gramPanchayat.length > 0 ? (
                            gramPanchayat.map((row, index) => (
                              <TableRow
                                key={index}
                                sx={{
                                  "&:last-child td, &:last-child th": { border: 0 },
                                }}
                              >
                                <TableCell
                                  component="th"
                                  scope="row"
                                  align="center"
                                >
                                  {index + 1}
                                </TableCell>
                                <TableCell align="center">
                                  {row.gram_panchayat_code}
                                </TableCell>
                                <TableCell align="center">
                                  {row.gram_panchayat}
                                </TableCell>
                              </TableRow>
                            ))
                          ) : (
                            <TableRow>
                              <TableCell align="center" colSpan={3}>
                                {" "}
                                <h4>
                                  <i>{"No data available"}</i>
                                </h4>
                              </TableCell>
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SachivProfile;
